import { apiConfig } from '../../../common/apiConfig'
import { createUserStore } from '../../../common/user/createUserStore'
import {
  AcceptorProfileApi,
  SignOutRequestRoleEnum,
  UserSessionsApi,
  UserSignInRequestRoleEnum,
} from '../../../generated'

const api = new AcceptorProfileApi(apiConfig)
const sapi = new UserSessionsApi(apiConfig)

const _load = api.acceptorCurrentProfile.bind(api)

async function _signIn(account: string, password: string, keep: boolean) {
  return sapi.userSignIn({ account, password, keep, role: UserSignInRequestRoleEnum.Aao })
}

async function _signOut() {
  return sapi.userSignOut({ role: SignOutRequestRoleEnum.Aao })
}

export const { signOut, onSignOut, onError, useUser } = createUserStore(_load, _signIn, _signOut)
